/*
 * Co-located server-data hooks for the super-admin Brands surface (U7).
 *
 * `POST /auth/brands` provisions a brand + its first admin in one call
 * (super-admin only; 403 otherwise). There is no roster GET, so this is a
 * mutation-only hook; the page tracks the admin's password in component state
 * so the super-admin can share it (admin-provisioned passwords are final).
 */

import { useMutation } from "@tanstack/react-query";
import { createBrand } from "../../../api/endpoints";
import type { CreateBrandResponse } from "../../../api/client";

interface CreateBrandVars {
  name: string;
  admin_email: string;
  admin_password: string;
}

/** Provision a brand + its first admin (super-admin only). */
export function useCreateBrand() {
  return useMutation<CreateBrandResponse, unknown, CreateBrandVars>({
    mutationFn: (vars) => createBrand(vars),
  });
}
